import React, { createContext, useContext, useState, ReactNode } from 'react';
import { CreditAnalytics } from '../types/api';

interface AnalyticsContextType {
  analytics: CreditAnalytics | null;
  setAnalytics: (analytics: CreditAnalytics | null) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

const AnalyticsContext = createContext<AnalyticsContextType | undefined>(undefined);

export function AnalyticsProvider({ children }: { children: ReactNode }) {
  const [analytics, setAnalytics] = useState<CreditAnalytics | null>(null);
  const [isLoading, setIsLoading] = useState(true); // Start as true until initial load

  return (
    <AnalyticsContext.Provider value={{ analytics, setAnalytics, isLoading, setIsLoading }}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export function useAnalytics() {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
}

